"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

exports.initialResidueContext = {
  addCandidateResidues: function addCandidateResidues(residues) {
    return;
  },
  addHoveredResidues: function addHoveredResidues(residues) {
    return;
  },
  addLockedResiduePair: function addLockedResiduePair(residues) {
    return;
  },
  candidateResidues: new Array(),
  clearAllResidues: function clearAllResidues() {
    return;
  },
  hoveredResidues: new Array(),
  lockedResiduePairs: new Map(),
  removeAllLockedResiduePairs: function removeAllLockedResiduePairs() {
    return;
  },
  removeCandidateResidues: function removeCandidateResidues() {
    return;
  },
  removeHoveredResidues: function removeHoveredResidues() {
    return;
  },
  removeLockedResiduePair: function removeLockedResiduePair(residues) {
    return;
  },
  removeNonLockedResidues: function removeNonLockedResidues() {
    return;
  },
  toggleLockedResiduePair: function toggleLockedResiduePair(residues) {
    return;
  }
};
exports.ResidueContext = React.createContext(exports.initialResidueContext);
exports.ResidueContextConsumer = exports.ResidueContext.Consumer;

var ResidueContextProvider =
/** @class */
function (_super) {
  __extends(ResidueContextProvider, _super);

  function ResidueContextProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.onAddCandidateResidues = function (candidateResidues) {
      _this.setState({
        candidateResidues: candidateResidues.sort()
      });
    };

    _this.onAddHoveredResidues = function (hoveredResidues) {
      _this.setState({
        hoveredResidues: hoveredResidues.sort()
      });
    };

    _this.onAddLockedResiduePair = function (residues) {
      var lockedResiduePairs = _this.state.lockedResiduePairs;
      var sortedResidues = residues.sort();
      var residuePairKey = sortedResidues.toString();

      if (!lockedResiduePairs.has(residuePairKey)) {
        var result = new Map(lockedResiduePairs);
        result.set(residuePairKey, sortedResidues);

        _this.setState({
          lockedResiduePairs: result
        });
      }
    };

    _this.onClearAllResidues = function () {
      _this.setState({
        candidateResidues: new Array(),
        hoveredResidues: new Array(),
        lockedResiduePairs: new Map()
      });
    };

    _this.onRemoveAllLockedResiduePairs = function () {
      _this.setState({
        lockedResiduePairs: new Map()
      });
    };

    _this.onRemoveCandidateResidue = function () {
      _this.setState({
        candidateResidues: new Array()
      });
    };

    _this.onRemoveHoveredResidues = function () {
      _this.setState({
        hoveredResidues: new Array()
      });
    };

    _this.onRemoveLockedResiduePair = function (residues) {
      var residuePairKey = residues.sort().join(',');
      var lockedResiduePairs = _this.state.lockedResiduePairs;

      if (lockedResiduePairs.has(residuePairKey)) {
        var result = new Map(lockedResiduePairs);
        result.delete(residuePairKey);

        _this.setState({
          lockedResiduePairs: result
        });
      }
    };

    _this.onRemoveNonLockedResidues = function () {
      _this.setState({
        candidateResidues: new Array(),
        hoveredResidues: new Array()
      });
    };

    _this.onToggleLockedResiduePair = function (residues) {
      var lockedResiduePairs = _this.state.lockedResiduePairs;
      var sortedResidues = residues.sort();
      var residuePairKey = sortedResidues.toString();
      var result = new Map(lockedResiduePairs);

      if (!lockedResiduePairs.has(residuePairKey)) {
        result.set(residuePairKey, sortedResidues);
      } else {
        result.delete(residuePairKey);
      }

      _this.setState({
        lockedResiduePairs: result
      });
    };

    _this.state = __assign({}, exports.initialResidueContext, {
      addCandidateResidues: _this.onAddCandidateResidues,
      addHoveredResidues: _this.onAddHoveredResidues,
      addLockedResiduePair: _this.onAddLockedResiduePair,
      clearAllResidues: _this.onClearAllResidues,
      removeAllLockedResiduePairs: _this.onRemoveAllLockedResiduePairs,
      removeCandidateResidues: _this.onRemoveCandidateResidue,
      removeHoveredResidues: _this.onRemoveHoveredResidues,
      removeLockedResiduePair: _this.onRemoveLockedResiduePair,
      removeNonLockedResidues: _this.onRemoveNonLockedResidues,
      toggleLockedResiduePair: _this.onToggleLockedResiduePair
    });
    return _this;
  }

  ResidueContextProvider.prototype.render = function () {
    return React.createElement(exports.ResidueContext.Provider, {
      value: this.state
    }, this.props.children);
  };

  return ResidueContextProvider;
}(React.Component);

exports.ResidueContextProvider = ResidueContextProvider;